
// NBA team abbreviations to full names
export const teamNames: Record<string, string> = {
  // Atlantic Division
  'BOS': 'Celtics',
  'BKN': 'Nets',
  'NYK': 'Knicks',
  'PHI': '76ers',
  'TOR': 'Raptors',
  // Central Division
  'CHI': 'Bulls',
  'CLE': 'Cavaliers',
  'DET': 'Pistons',
  'IND': 'Pacers',
  'MIL': 'Bucks',
  // Southeast Division
  'ATL': 'Hawks',
  'CHA': 'Hornets',
  'MIA': 'Heat',
  'ORL': 'Magic',
  'WAS': 'Wizards',
  // Northwest Division
  'DEN': 'Nuggets',
  'MIN': 'Timberwolves',
  'OKC': 'Thunder',
  'POR': 'Trail Blazers',
  'UTA': 'Jazz',
  // Pacific Division
  'GSW': 'Warriors',
  'LAC': 'Clippers',
  'LAL': 'Lakers',
  'PHX': 'Suns',
  'SAC': 'Kings',
  // Southwest Division
  'DAL': 'Mavericks',
  'HOU': 'Rockets',
  'MEM': 'Grizzlies',
  'NOP': 'Pelicans',
  'SAS': 'Spurs',
};

// Full team names with cities
export const fullTeamNames: Record<string, string> = {
  // Atlantic Division
  'BOS': 'Boston Celtics',
  'BKN': 'Brooklyn Nets',
  'NYK': 'New York Knicks',
  'PHI': 'Philadelphia 76ers',
  'TOR': 'Toronto Raptors',
  // Central Division
  'CHI': 'Chicago Bulls',
  'CLE': 'Cleveland Cavaliers',
  'DET': 'Detroit Pistons',
  'IND': 'Indiana Pacers',
  'MIL': 'Milwaukee Bucks',
  // Southeast Division
  'ATL': 'Atlanta Hawks',
  'CHA': 'Charlotte Hornets',
  'MIA': 'Miami Heat',
  'ORL': 'Orlando Magic',
  'WAS': 'Washington Wizards',
  // Northwest Division
  'DEN': 'Denver Nuggets',
  'MIN': 'Minnesota Timberwolves',
  'OKC': 'Oklahoma City Thunder',
  'POR': 'Portland Trail Blazers',
  'UTA': 'Utah Jazz',
  // Pacific Division
  'GSW': 'Golden State Warriors',
  'LAC': 'Los Angeles Clippers',
  'LAL': 'Los Angeles Lakers',
  'PHX': 'Phoenix Suns',
  'SAC': 'Sacramento Kings',
  // Southwest Division
  'DAL': 'Dallas Mavericks',
  'HOU': 'Houston Rockets',
  'MEM': 'Memphis Grizzlies',
  'NOP': 'New Orleans Pelicans',
  'SAS': 'San Antonio Spurs',
};

// City names
export const teamCities: Record<string, string> = {
  'BOS': 'Boston',
  'BKN': 'Brooklyn',
  'NYK': 'New York',
  'PHI': 'Philadelphia',
  'TOR': 'Toronto',
  'CHI': 'Chicago',
  'CLE': 'Cleveland',
  'DET': 'Detroit',
  'IND': 'Indiana',
  'MIL': 'Milwaukee',
  'ATL': 'Atlanta',
  'CHA': 'Charlotte',
  'MIA': 'Miami',
  'ORL': 'Orlando',
  'WAS': 'Washington',
  'DEN': 'Denver',
  'MIN': 'Minnesota',
  'OKC': 'Oklahoma City',
  'POR': 'Portland',
  'UTA': 'Utah',
  'GSW': 'Golden State',
  'LAC': 'Los Angeles',
  'LAL': 'Los Angeles',
  'PHX': 'Phoenix',
  'SAC': 'Sacramento',
  'DAL': 'Dallas',
  'HOU': 'Houston',
  'MEM': 'Memphis',
  'NOP': 'New Orleans',
  'SAS': 'San Antonio',
};

// MLB team abbreviations to mascot names
export const mlbTeamNames: Record<string, string> = {
  'AZ': 'Diamondbacks', 'ATL': 'Braves', 'BAL': 'Orioles', 'BOS': 'Red Sox',
  'CHC': 'Cubs', 'CWS': 'White Sox', 'CIN': 'Reds', 'CLE': 'Guardians',
  'COL': 'Rockies', 'DET': 'Tigers', 'HOU': 'Astros', 'KC': 'Royals',
  'LAA': 'Angels', 'LAD': 'Dodgers', 'MIA': 'Marlins', 'MIL': 'Brewers',
  'MIN': 'Twins', 'NYM': 'Mets', 'NYY': 'Yankees', 'ATH': 'Athletics',
  'PHI': 'Phillies', 'PIT': 'Pirates', 'SD': 'Padres', 'SF': 'Giants',
  'SEA': 'Mariners', 'STL': 'Cardinals', 'TB': 'Rays', 'TEX': 'Rangers',
  'TOR': 'Blue Jays', 'WSH': 'Nationals',
};

// MLB full team names with cities
export const mlbFullTeamNames: Record<string, string> = {
  'AZ': 'Arizona Diamondbacks', 'ATL': 'Atlanta Braves', 'BAL': 'Baltimore Orioles',
  'BOS': 'Boston Red Sox', 'CHC': 'Chicago Cubs', 'CWS': 'Chicago White Sox',
  'CIN': 'Cincinnati Reds', 'CLE': 'Cleveland Guardians', 'COL': 'Colorado Rockies',
  'DET': 'Detroit Tigers', 'HOU': 'Houston Astros', 'KC': 'Kansas City Royals',
  'LAA': 'Los Angeles Angels', 'LAD': 'Los Angeles Dodgers', 'MIA': 'Miami Marlins',
  'MIL': 'Milwaukee Brewers', 'MIN': 'Minnesota Twins', 'NYM': 'New York Mets',
  'NYY': 'New York Yankees', 'ATH': 'Athletics', 'PHI': 'Philadelphia Phillies',
  'PIT': 'Pittsburgh Pirates', 'SD': 'San Diego Padres', 'SF': 'San Francisco Giants',
  'SEA': 'Seattle Mariners', 'STL': 'St. Louis Cardinals', 'TB': 'Tampa Bay Rays',
  'TEX': 'Texas Rangers', 'TOR': 'Toronto Blue Jays', 'WSH': 'Washington Nationals',
};

